import { Pipe, PipeTransform } from "@angular/core";
import { DropDownOption } from "src/app/product-capture/model/interfaces/drop-down-option.interface";
import { ReferenceEntity } from "src/app/static-data/models/interfaces/static-data";

@Pipe({
    name: 'filterEntities'
})
export class FilterEntitiesPipe implements PipeTransform {
    transform(selectedEntitiesIds: number[], index: number, entities: { [key: string]: DropDownOption[] }, referenceEntityItems: ReferenceEntity[]): DropDownOption[] {
        const key = index.toString();

        if (!entities.hasOwnProperty(key)) {
            entities[key] = FilterEntitiesPipe.getEntityOptions(referenceEntityItems);
        }

        return entities[key].filter((entity: DropDownOption) => !selectedEntitiesIds.includes(entity.id));
    }

    static getEntityOptions(referenceEntityItems: ReferenceEntity[]): DropDownOption[] {
        const options: ReferenceEntity[] = JSON.parse(JSON.stringify(referenceEntityItems));
        const getEntity = (entity: ReferenceEntity) => ({
            id: entity.referenceEntityID,
            displayValue: entity.longName,
        } as DropDownOption);

        const getOptions = (list: ReferenceEntity[]) => list.map((entity) => getEntity(entity));
        return getOptions(options);
    }
}